import routes from 'routes/constants'
import type { FastSearchResultItem } from '../api/swagger/definitions/backoffice'

export const createRoutePath = (row: FastSearchResultItem) => {
  const defaultPath = `${routes.CUSTOMERS_PATH}/${row.customerId}`

  const paths = {
    CUSTOMER: `${routes.CUSTOMERS_PATH}/${row.customerId}`,
    PERSON: `${routes.CUSTOMERS_PATH}/${row.customerId}`,
  }

  return paths[row.type] ?? defaultPath
}
